import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { useQuery } from '@tanstack/vue-query';
import type { GetExperiencesData, GetExperiencesRequest } from '@/shared/api/experience';
import { useUnlicensedContentFilter } from '@/shared/composables/useUnlicensedContentFilter.ts';
import { useListingLabelsV3Experiment } from '@/features/experiments';

export const useGetExperiences = (params: Ref<GetExperiencesData['query']>, enabled?: MaybeRefOrGetter<boolean>) => {
  const { getExperiences } = useExperienceApi();
  const { isListingLabelsV3ExperimentActive } = useListingLabelsV3Experiment();
  const { hideUnlicensed } = useUnlicensedContentFilter();

  const {
    data: experiencesData,
    isFetching,
    isFetched,
  } = useQuery({
    queryKey: ['getExperiences', params],
    queryFn: async () => {
      const response = await getExperiences({
        query: {
          ...params.value,
          extended_movement_types: true,
          exclude_needs_license: hideUnlicensed.value,
          include_labels: isListingLabelsV3ExperimentActive,
          photos_count: 1,
        },
      });

      return response.data;
    },
    enabled: computed(() => !!unref(enabled !== undefined ? enabled : computed(() => true))),
    placeholderData: (prevData): GetExperiencesRequest =>
      prevData || { count: 0, next: null, previous: null, results: [] },
    refetchOnWindowFocus: false,
  });

  return {
    experiencesData,
    isFetching,
    isFetched,
  };
};
